import React, { Component } from 'react';
import { Form, Input, Button, Row, Col, InputNumber, message } from 'antd';
import { connect } from 'react-redux';
import * as actions from '../redux/actions/agents';

class CreateAgent extends Component {
    formRef = React.createRef();
    layout = {
        labelCol: {
            span: 8,
        },
        wrapperCol: {
            span: 16,
        },
    };
    tailLayout = {
        wrapperCol: {
            offset: 8,
            span: 16,
        },
    };

    onFinish = async (values) => {
        await this.props.onCreate({ name: values.name, mobile: values.mobile, balance: values.balance }, this.props.token);
        await this.props.onGet(this.props.token);
        if(this.props.message){
            message.success(this.props.message);
        }
        if(this.props.error){
            message.success(this.props.error);
        }
        this.formRef.current.resetFields();
    };
    

    onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };
    render() {
        return (
            <Row justify="left" align="middle">
                <Col lg={8} sm={20}>
                    <Form
                        {...this.layout}
                        name="basic"
                        initialValues={{
                            remember: true,
                        }}
                        onFinish={this.onFinish}
                        onFinishFailed={this.onFinishFailed}
                        ref={this.formRef}
                    >
                        <Form.Item
                            label="Agent Name"
                            name="name"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input agent name!',
                                },
                                { min: 3, message: 'Agent Name must be minimum 3 characters.' },
                            ]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label="Mobile"
                            name="mobile"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input mobile number!',
                                },
                                { min: 9, message: 'Minimum 9 characters.' },
                            ]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label="Initial Balance"
                            name="balance"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input balance!',
                                },
                            ]}
                        >
                            <InputNumber
                                style={{ width: 180 }}
                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            />
                        </Form.Item>
                        <Form.Item {...this.tailLayout}>
                            <Button type="primary" htmlType="submit">
                                Create
                            </Button>
                        </Form.Item>
                    </Form>
                </Col>
            </Row>
        );
    }

};
const mapStateToProps = state => {
    return {
        token: state.auth.token,
        error: state.agents.error,
        message: state.agents.message,
    }
}
const mapDispatchToProps = dispatch => {
    return {
        onCreate: (agent, token) => dispatch(actions.createAgent(agent, token)),
        onGet:(token)=>dispatch(actions.getAgents(token)),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(CreateAgent);